import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, inject } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideGroundworksAuth } from "@groundworks/ngx-groundworks-auth";
import { routes } from "./app.routes";
import { API_BASE_URL } from "./sdk/sdk";
import { ConfigService } from "./config.service";
import { buildGroundworksAuthConfig, resolveApiUrl } from "./auth.config";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    { 
      provide: API_BASE_URL, 
      useFactory: (config: ConfigService) => resolveApiUrl(config),
      deps: [ConfigService] 
    },
    provideRouter(routes),
    provideGroundworksAuth(() => buildGroundworksAuthConfig(inject(ConfigService))),
  ]
};
